import { render } from "./SynodicOrbitObjectsList.vue?vue&type=template&id=4f054398"
import script from "./SynodicOrbitObjectsList.vue?vue&type=script&lang=js"
export * from "./SynodicOrbitObjectsList.vue?vue&type=script&lang=js"

import "./SynodicOrbitObjectsList.vue?vue&type=style&index=0&id=4f054398&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__